import React from "react";
import axios from "axios";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useUser } from './UserContext';
import LogoutIcon from '@mui/icons-material/Logout';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const UserLogOut = ({ username }) => {
  const navigate = useNavigate();
  const { setUsername: setGlobalUsername } = useUser();

  const handleLogout = async () => {
    try {
      // Make a request to the backend to update Active_Status to 1
      const response = await axios.post(`${API_BASE_URL}/userlogout`, { username });
      
      // Check if the backend transaction was successful
      if (response.status === 200 && response.data.message === "User availability updated successfully") {
        // Proceed with logout actions
        setGlobalUsername("");  // Clear username from global state
        localStorage.removeItem('username');  // Remove username from local storage
        navigate("/");  // Redirect to the login page
      } else {
        console.warn("Logout transaction did not complete as expected.");
      }
    } catch (error) {
      console.error("Error logging out:", error);
      alert("An error occurred during logout. Please try again.");
    }
  };

  return (
    <Button
      sx={{ minWidth: 170 }} 
      variant="outlined"  
      onClick={handleLogout} 
      startIcon={<LogoutIcon />}
    >
      Logout
    </Button>
  );
};

export default UserLogOut;
